import React from "react";
import WidgetFrame from "./WidgetFrame";
import SignalRow from "./SignalRow";
import EmptyRow from "./EmptyRow";
import type { Signal } from "../../utils/operationsDashboard";

interface NeedsAttentionWidgetProps {
  signals: Signal[];
  windowLabel: string;
  isLoading?: boolean;
  /** True when a source failed to load, so an empty list is not claimed as an all-clear. */
  incomplete?: boolean;
  className?: string;
}

// Names the open faults, worst first; unsliced, since the frame scrolls and a count of 13 over four rows hid nine
const NeedsAttentionWidget: React.FC<NeedsAttentionWidgetProps> = ({
  signals,
  windowLabel,
  isLoading,
  incomplete = false,
  className,
}) => (
  <WidgetFrame
    title="Alerts"
    meta={windowLabel.toLowerCase()}
    metaAlign="right"
    count={signals.length}
    isLoading={isLoading}
    padBody={false}
    scrollBody
    className={className}
  >
    {signals.length === 0 ? (
      <div className="px-5 py-3">
        <EmptyRow>
          {incomplete ? "Nothing to show — some data didn’t load." : "Nothing needs attention."}
        </EmptyRow>
      </div>
    ) : (
      /* px-3 + the row's own px-2 puts the text on the header's 20px content left, as the asset list does */
      <div className="flex flex-col gap-1 px-3 py-2">
        {signals.map((signal) => (
          <SignalRow key={signal.id} signal={signal} />
        ))}
      </div>
    )}
  </WidgetFrame>
);

export default NeedsAttentionWidget;
